import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { INote } from '@interfaces/INoteData';
import { IAppState } from '@myStore/app.state';
import {
  ClearNoteAboutStudentErrors,
  EditNoteAboutStudentRequest,
} from '@myStore/users-changes/users-changes.actions';
import { selectUsersChangesSuccess } from '@myStore/users-changes/users-changes.selector';
import { select, Store } from '@ngrx/store';
import { FormDialogComponent } from '@shared/components/UI/form-dialog/form-dialog.component';
import { isControlsIsValid } from '@shared/utils/formUtils';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-student-note-edit',
  templateUrl: './student-note-edit.component.html',
  styleUrls: ['./student-note-edit.component.sass'],
})
export class StudentNoteEditComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  note?: INote | null = null;
  sendLoading$!: Observable<boolean>;
  deductionForm = new UntypedFormGroup({
    student: new UntypedFormControl(''),
    type: new UntypedFormControl(''),
    text: new UntypedFormControl('', [Validators.required]),
    group: new UntypedFormControl(0),
  });

  constructor(
    private _store: Store<IAppState>,
    private _dialog: MatDialog,
    public dialogRef: MatDialogRef<FormDialogComponent>
  ) {}

  ngOnInit(): void {
    const dialogData = this.dialogRef.componentInstance.data;
    this.note = dialogData.note;
    this.sendLoading$ = dialogData.loading$;

    this.deductionForm.patchValue({
      student: dialogData.student?.id,
      type: dialogData.note?.type,
      group: dialogData.note?.group,
      text: dialogData.note?.text,
    });

    this._store
      .pipe(select(selectUsersChangesSuccess), takeUntil(this.destroy$))
      .subscribe(success => {
        if (success) {
          this._store.dispatch(new ClearNoteAboutStudentErrors());
          this.onCancel();
        }
      });
  }

  editNoteAboutUser() {
    const data = this.deductionForm.value;

    if (isControlsIsValid(this.deductionForm.controls) && this.note) {
      this._store.dispatch(
        new EditNoteAboutStudentRequest(this.note?.id, data)
      );
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this._store.dispatch(new ClearNoteAboutStudentErrors());
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
